import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomerApplication } from 'services/CustomerService'
import { QueryMetaType } from 'types/reactQuery'

export const useCustomerV2Query = <CustomerDetails extends object>(id: string) => {
  const meta: QueryMetaType = {
    excludedErrorCodes: [404],
  }

  return useQuery({
    queryKey: reactQueryKeys.customerV2(id),
    queryFn: () => getCustomerApplication<CustomerDetails>(id),
    enabled: !!id,
    meta,
  })
}
